import React, { useState } from "react";
import {
  Card, CardContent, Typography, Box, Button, TextField, MenuItem,
  Select, FormControl, Grid, InputLabel, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper
} from "@mui/material";
import axios from "axios";
import config from "../config";

const EquipmentReservationReport = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [reservations, setReservations] = useState([]);
  const [equipmentNames, setEquipmentNames] = useState([]);
  const [selectedEquipment, setSelectedEquipment] = useState("");

  const handleSubmit = async () => {
    if (!selectedLocation || !fromDate || !toDate) {
      setError("Please select all fields.");
      return;
    }

    setError("");
    setLoading(true);
    try {
      const response = await axios.get(`${config.API_BASE_URL}/equipmentReservation/getEquipmentReservations`, {
        params: {
          selectedLocation,
          from: fromDate,
          to: toDate
        }
      });

      const data = response.data;
      setReservations(data);

      // Extract unique equipment names
      const uniqueEquipments = [...new Set(data.map(item => item.equipmentName))];
      setEquipmentNames(uniqueEquipments);

    } catch (err) {
      console.error("Error fetching equipment data:", err);
      setReservations([]);
      setEquipmentNames([]);
      setError(err.response?.data?.message || "Something went wrong.");
    }
    setLoading(false);
  };

  const filteredReservations = selectedEquipment
    ? reservations.filter(item => item.equipmentName === selectedEquipment)
    : reservations;

  return (
    <Box sx={{ flexGrow: 1, padding: "10px", paddingLeft: "260px", paddingTop: "60px" }}>
      <Card sx={{ width: "100%", padding: "15px", borderRadius: "10px", borderTop: "4px solid blue" }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Reserved Equipments
          </Typography>
          <hr />
          {error && <Typography color="error">{error}</Typography>}

          <Grid container spacing={2} alignItems="center">
            <Grid item xs={3}>
              <FormControl fullWidth disabled={loading}>
                <InputLabel>Select Location</InputLabel>
                <Select
                  value={selectedLocation}
                  onChange={(e) => setSelectedLocation(e.target.value)}
                >
                  <MenuItem value="Factory">Factory</MenuItem>
                  <MenuItem value="HeadOffice">Head Office</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                type="date"
                label="From Date"
                InputLabelProps={{ shrink: true }}
                value={fromDate}
                onChange={(e) => setFromDate(e.target.value)}
              />
            </Grid>

            <Grid item xs={3}>
              <TextField
                fullWidth
                type="date"
                label="To Date"
                InputLabelProps={{ shrink: true }}
                value={toDate}
                onChange={(e) => setToDate(e.target.value)}
              />
            </Grid>

            <Grid item xs={3}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={loading}
                fullWidth
              >
                {loading ? "Loading..." : "Get Reservations Detail"}
              </Button>
            </Grid>
          </Grid>

          {/* Equipment Filter Dropdown */}
          {equipmentNames.length > 0 && (
            <Box sx={{ mt: 2 }}>
              <FormControl fullWidth>
                <InputLabel>Filter by Equipment</InputLabel>
                <Select
                  value={selectedEquipment}
                  onChange={(e) => setSelectedEquipment(e.target.value)}
                  label="Filter by Equipment"
                >
                  <MenuItem value="">All Equipments</MenuItem>
                  {equipmentNames.map((name, index) => (
                    <MenuItem key={index} value={name}>
                      {name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Box>
          )}

          {/* Table */}
          {filteredReservations.length > 0 && (
            <TableContainer component={Paper} sx={{ mt: 4 }}>
              <Table sx={{ minWidth: 650 }}>
                <TableHead sx={{ background: "#0c2a73" }}>
                  <TableRow>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>S.No.</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Location</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Equipment</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Reserved By</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Start Time</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>End Time</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Emp Code</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Purpose</TableCell>
                    <TableCell sx={{ color: "white", fontWeight: "bold", fontSize: "16px" }}>Status</TableCell>
                    {/* <TableCell sx={{ color:"white", fontWeight: "bold", fontSize: "16px" }}>Timestamp</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filteredReservations.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{item.selectedLocation}</TableCell>
                      <TableCell>{item.equipmentName}</TableCell>
                      <TableCell>{item.reserveBy}</TableCell>
                      <TableCell>{new Date(item.selectedStartDate).toLocaleString()}</TableCell>
                      <TableCell>{new Date(item.selectedEndDate).toLocaleString()}</TableCell>
                      <TableCell>{item.EmpCode}</TableCell>
                      <TableCell>{item.purposeOfEquipment}</TableCell>
                      <TableCell>{item.status}</TableCell>
                      {/* <TableCell>{item.timestamp ? new Date(item.timestamp).toLocaleString() : "N/A"}</TableCell> */}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default EquipmentReservationReport;
